<header nx-header [class.non-prod]="isNonProdEnvironment">
  <nx-header-row>
    <nx-header-brand>
      <figure nxFigure>
        <img src="./assets/Allianz_Logo.svg" alt="Brand Logo" role="none" />
      </figure>
    </nx-header-brand>
    <nx-header-actions>
      @if (isNonProdEnvironment) {
        <span class="env-section">
          <pre class="env nx-font-weight-light">{{ 'Environment' | transloco }}: </pre>
          <p>{{ currentEnvironment | uppercase }}</p>
        </span>
      }
      <app-dropdown-language></app-dropdown-language>
      <app-accessibility></app-accessibility>
    </nx-header-actions>
  </nx-header-row>
</header>

<main>
  <router-outlet />
</main>

<nx-footer>
  <nx-footer-copyright>
    &copy; {{ currentYear }} Allianz Trade
  </nx-footer-copyright>

  <nx-footer-navigation>
    <nx-footer-link>
      <a routerLink="/legal-notice">{{ 'Legal Notice' | transloco }}</a>
    </nx-footer-link>
    <nx-footer-link>
      <a href="https://www.allianz-trade.fr/recouvrement/carte.html?paysoft=1" target="_blank">{{ 'Contact' | transloco }}</a>
    </nx-footer-link>
    <nx-footer-link>
      <a href="https://www.allianz-trade.fr/politique-protection-donnees.html" target="_blank">{{ 'Data Protection' | transloco }}</a>
    </nx-footer-link>
  </nx-footer-navigation>
</nx-footer>
